import { render, staticRenderFns } from "./ComandoVelocidadNuevo.vue?vue&type=template&id=2a352e5a&"
import script from "./ComandoVelocidadNuevo.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidadNuevo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports